import React from 'react'

const SectionContext = React.createContext('section1')

export default SectionContext
